module.exports = __webpack_public_path__ + "img/zizhi5.0c7b4b52.jpg";